module.exports = __webpack_public_path__ + "static/media/Major Project EXTC 2020-21.d8da2d16.pdf";